

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy'
import Support from './Support/Support'
import AccountDeleteStep from './AccountDeleteStep/AccountDeleteStep'
import PrivacyPolicySales from './PrivacyPolicySales/PrivacyPolicySales'
import SupportSales from './SupportSales/SupportSales'
import AccountDeleteStepSales from './AccountDeleteStepSales/AccountDeleteStepSales'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
          <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
          <Route path='/PrivacyPolicySales' element={<PrivacyPolicySales />} />
          <Route path='/Support' element={<Support />} />
          <Route path='/SupportSales' element={<SupportSales />} />
          <Route path='/steps-account-delete' element={<AccountDeleteStep />} />
          <Route path='/steps-account-delete-sales' element={<AccountDeleteStepSales />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
